module.exports = __webpack_public_path__ + "static/lydie-Normal-ffd9a97716c91cdd88997d8f4ac347af.jpg";